import { client } from './client'
import { ExecutiveMetricsResponse, LoadExecutiveMetricsPayload } from '@views/executiveMetrics/types'

export const getExecutiveMetrics = async (
  cocap: string,
  filters: LoadExecutiveMetricsPayload
): Promise<ExecutiveMetricsResponse> => {
  const response = await client.get<ExecutiveMetricsResponse>('/executive-metrics', {
    headers: { cocap },
    params: { period: filters.period, year: filters.year }
  })
  return response.data
}
